exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recommend-trial-container[data-v-2d958814] {\n  text-align: center;\n  background: -webkit-gradient(linear, left top, right top, from(#D70370), to(#A81FF8));\n  background: linear-gradient(to right, #D70370, #A81FF8);\n  color: #ffffff;\n  padding: 40px 24px;\n}\n.trial-button-component[data-v-2d958814] {\n  margin-top: 16px;\n}\n@media screen and (max-width: 480px) {\n.recommend-trial-container[data-v-2d958814] {\n    padding: 24px 8px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d958814","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LP/RecommendTrial.vue
// module id = fqtB
// module chunks = 3